/* eslint-disable indent */
/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 16:04:11
 * @LastEditTime: 2020-12-17 11:39:58
 * @FilePath: \ensurance-front\src\router\modules\integratedQuery.js
 */
const IntegratedQuery = () => import(/* webpackChunkName: 'IntegratedQuery' */ '@/views/integrated-query/integrated-query.vue')
const PersonnelSettlement = () => import('@/views/integrated-query/personnel-Settlement-list/personnel-Settlement-list.vue')
const EnterpriseReimbursementList = () => import('@/views/integrated-query/enterprise-reimbursement-list/enterprise-reimbursement-list.vue')
const PersonApplicationList = () => import('@/views/integrated-query/person-application-list/person-application-list.vue')
const PersonReturn = () => import('@/views/integrated-query/person-return/person-return.vue')
const PersonStop = () => import('@/views/integrated-query/person-stop/person-stop.vue')
const PersonSuspend = () => import('@/views/integrated-query/person-suspend/person-suspend.vue')
const PersonReissue = () => import('@/views/integrated-query/person-reissue/person-reissue.vue')
const SettleSuspend = () => import('@/views/integrated-query/settle-suspend/settle-suspend.vue')
const DifferenceList = () => import('@/views/integrated-query/difference-list/difference-list.vue')
const ReserveCollection = () => import('@/views/integrated-query/reserve-collection/reserve-collection.vue')

export default [
    {
        path: '/integratedQuery',
        name: 'IntegratedQuery',
        component: IntegratedQuery,
        children: [
            {
                path: '/integratedQuery/person_settlement_audit',
                name: 'PersonnelSettlement',
                component: PersonnelSettlement
            },
            {
                path: '/integratedQuery/difference_audit',
                name: 'DifferenceList',
                component: DifferenceList

            },
            {
                path: '/integratedQuery/reserve_collection_audit',
                name: 'ReserveCollection',
                component: ReserveCollection
            },
            {
                path: '/integratedQuery/firm_reimbursement_audit',
                name: 'EnterpriseReimbursementList',
                component: EnterpriseReimbursementList
            },
            {
                path: '/integratedQuery/application_audit',
                name: 'PersonApplicationList',
                component: PersonApplicationList
            },
            {
                path: '/integratedQuery/person_return_audit',
                name: 'PersonReturn',
                component: PersonReturn
            },
            {
                path: '/integratedQuery/person_stop_audit',
                name: 'PersonStop',
                component: PersonStop
            },
            {
                path: '/integratedQuery/person_suspend_audit',
                name: 'PersonSuspend',
                component: PersonSuspend
            },
            {
                path: '/integratedQuery/person_reissue_audit',
                name: 'PersonReissue',
                component: PersonReissue
            },
            {
                path: '/integratedQuery/settle_suspend_audit',
                name: 'SettleSuspend',
                component: SettleSuspend
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/auditMenu.js